<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="hero-single">
    <div class="hero-single-inner wrapper">
      <h1 class="hero-single__title h2" v-html="content.title"></h1>
      <h2
        v-if="content.htmltext"
        class="hero-single__text body-text"
        v-html="content.htmltext"
      ></h2>
      <GPicture
        v-if="content.picture"
        :content="content.picture"
        class="hero-single__picture cover"
        :default-sizes="defaultImageSize"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { Picture } from '@/types'

export interface HeroBasic {
  title: string
  htmltext?: string
  picture?: Picture
}
</script>

<script setup lang="ts">
import { useHead } from '@vueuse/head'

import { parseSets } from '@/modules/utils'

import type { PropType } from 'vue'

const props = defineProps({
  content: {
    type: Object as PropType<HeroBasic>,
    required: true,
  },
})

const defaultImageSize = '100vw'

if (props.content?.picture) {
  useHead({
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: props.content?.picture?.src,
        imagesrcset:
          props.content?.picture?.sets && parseSets(props.content.picture.sets),
        imagesizes: defaultImageSize,
      },
    ],
  })
}
</script>

<style lang="scss" scoped>
.hero-single {
  // prettier-ignore
  @include fluid(margin-bottom, (xxs: 4rem, xxl: 12rem));

  position: relative;
}

.hero-single-inner {
  height: 100%;
}

.hero-single__title {
  @extend %fw-light;

  position: relative;
  z-index: 1;
  max-width: 120rem;
  margin: 0 auto 4.8rem;
  padding-top: $header-height-mobile;
  color: $c-green-abr;
  text-align: center;

  @include mq(l) {
    padding-top: $header-height;
  }
}

.hero-single__text {
  max-width: 70rem;
  margin: auto;
  text-align: center;
}

.hero-single__picture {
  @extend %br-default;

  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 160/62;
}
</style>
